import { msg } from '@lingui/macro'
import { resolveSectionDisplayLabel } from './config-localization'

const SECTION_HEADER_BY_KEY = {
  crash: msg`Crash`,
  road: msg`Road`,
  organization: msg`Organization`,
  units: msg`Traffic unit`,
  people: msg`Person`,
}

export function resolveGridSectionHeaderLabel(sectionKey, configuration, translate) {
  const descriptor = SECTION_HEADER_BY_KEY[sectionKey]
  if (descriptor && translate) {
    const translated = translate(descriptor)
    if (typeof translated === 'string') return translated
  }
  if (!configuration?.[sectionKey]) return sectionKey
  return resolveSectionDisplayLabel(configuration[sectionKey]) || sectionKey
}
